export default __webpack_public_path__ + "static/media/download.470db390.png";